import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { MoreIcon } from '@diligentcorp/atlas-react-icons';
import { paths } from '@issuemanager/apps/client/paths';

export default function () {
  const { t } = useTranslation(['issue', 'settings']);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        variant='outlined'
        onClick={handleClick}
        id='admin-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreIcon />
      </Button>

      <Menu
        id='admin-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'admin-button',
        }}
      >
        <MenuItem
          component={Link}
          to={`${paths.settings.index}/${paths.issueTypes.index}`}
          onClick={handleClose}
        >
          {t('settings:routeName')}
        </MenuItem>
      </Menu>
    </Box>
  );
}
